import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accreditation',
  templateUrl: './accreditation.component.html',
  styleUrls: ['./accreditation.component.scss']
})
export class AccreditationComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {
  }

}
